import http from "../axios/http-common";

class InterfaceSkriningRisikoJatuh {
  getSkriningRisikoJatuh(unit, reg) {
    return http.getDataParam(`/skrining-risiko-jatuh-ralan/register/${reg}`, {
      params: {
        unit_id: unit
      }
    });
  }
  getSkriningRisikoJatuhByReg(unit, reg) {
    return http.getDataParam(`/skrining-risiko-jatuh-ralan/register/${reg}`, {
      params: {
        unit_id: unit
      }
    });
  }
  getSkriningRisikoJatuhByRm(rm) {
    return http.getData(`/rm/${rm}/skrining-risiko-jatuh-ralan`);
  }
  saveSkriningRisikoJatuh(reg, rm, unit_id, risiko1, risiko2, waktu_periksa, petugas_id) {
    return http.postData(`/skrining-risiko-jatuh-ralan`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      risiko1: risiko1,
      risiko2: risiko2,
      waktu_periksa: waktu_periksa,
      petugas_id: petugas_id,
    });
  }
  editSkriningRisikoJatuh(id, reg, rm, unit_id, risiko1, risiko2, waktu_periksa, petugas_id) {
    return http.putData(`/skrining-risiko-jatuh-ralan/${id}`, {
      register_id: reg,
      pasien_rm: rm,
      unit_id: unit_id,
      risiko1: risiko1,
      risiko2: risiko2,
      waktu_periksa: waktu_periksa,
      petugas_id: petugas_id,
    });
  }
}
export default new InterfaceSkriningRisikoJatuh();
